import moment from "moment";
import {useState} from "react";
import AgyleButton from "../ui/buttons/agyleButton";
import makeStyles from "@mui/styles/makeStyles";
import {useTranslation} from "react-i18next";
import DatePicker from "@mui/lab/DatePicker";
import TextField from "@mui/material/TextField";
import clsx from "clsx";
import {Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import BedasCalendarElement from "./calendarComponent/bedasCalendarElement";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

const useStyles = makeStyles((theme) => ({
    divRow: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
    },
    textField: {
        width: "100%",
        backgroundColor: theme.palette.background.field,
        borderRadius: 10,
        "& fieldset": {
            border: "none",
        },
    },
    center: {
        marginLeft: "auto",
        marginRight: "auto",
        width: "fit-content",
        marginBottom: 5,
    },
    disable: {
        color: "gray",
    },
}));

const AgyleCalendar = (props) => {
    const classes = useStyles();
    const {t} = useTranslation();

    // State
    const [selectedMonth, setSelectedMonth] = useState(moment());

    // Calendar
    const weeks = [];
    const startOfMonth = selectedMonth.clone().startOf("month");
    const endOfMonth = selectedMonth.clone().endOf("month");
    const startOfWeek = startOfMonth.clone().startOf("week");
    const endOfWeek = endOfMonth.clone().endOf("week");

    let date = startOfWeek.clone();

    while (date.isSameOrBefore(endOfWeek)) {
        const week = [];
        for (let i = 0; i < 7; i++) {
            week.push(date.clone());
            date.add(1, "day");
        }
        weeks.push(week);
    }

    const handlePrevMonth = () => {
        setSelectedMonth(selectedMonth.clone().subtract(1, "month"));
    };

    const handleNextMonth = () => {
        setSelectedMonth(selectedMonth.clone().add(1, "month"));
    };

    const isDateFromOtherMonth = (date) => {
        return !date.isBetween(startOfMonth, endOfMonth, null, "[]");
    };

    const renderCalendarElement = (day, isFromOtherMonth) => {
        switch (props.type) {
            case "bedas":
                return (
                    <BedasCalendarElement
                        calendarType="monthly"
                        day={day}
                        isFromOtherMonth={isFromOtherMonth}
                        events={props.events}
                        handleSelectDate={props.handleSelectDate}
                    />
                );
            default:
                return day.format("D");
        }
    };

    return (
        <div style={{width: "100%"}}>
            <div className={clsx(classes.divRow, classes.center)}>
                <AgyleButton
                    size="small"
                    onClick={handlePrevMonth}
                    startIcon={<ArrowLeftIcon/>}
                >
                    {t("Prev")}
                </AgyleButton>

                <div style={{margin: "0 10px"}}>
                    <DatePicker
                        views={["month", "year"]}
                        value={selectedMonth}
                        onChange={setSelectedMonth}
                        renderInput={(inp) => <TextField
                            size="small"
                            className={classes.textField}
                            color="tertiary"
                            {...inp}
                        />}
                    />
                </div>

                <AgyleButton
                    size="small"
                    onClick={handleNextMonth}
                    endIcon={<ArrowRightIcon/>}
                >
                    {t("Next")}
                </AgyleButton>
            </div>

            <Table style={{tableLayout: "fixed"}}>
                <TableHead>
                    <TableRow>
                        {moment.weekdaysShort(true).map(day => (
                            <TableCell
                                key={day}
                                align="center"
                                padding="none"
                            >
                                {day}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {weeks.map((week, index) => (
                        <TableRow key={index}>
                            {week.map(date => (
                                <TableCell
                                    key={date.format("YYYY-MM-DD")}
                                    className={
                                        clsx((isDateFromOtherMonth(date) && !props.type) && classes.disable)}
                                >
                                    {renderCalendarElement(date, isDateFromOtherMonth(date))}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

export default AgyleCalendar;